<div
  *transloco="let transloco"
  [ngClass]="this.props.containerClass || 'flex min-h-9 items-center gap-2'">
  <p-checkbox
    [binary]="this.props.binary || true"
    [ngClass]="{
      'ng-dirty ng-invalid p-invalid': this.showError
    }"
    [readonly]="this.props.readonly"
    [formControl]="this.formControl"
    [formlyAttributes]="this.field">
  </p-checkbox>
  @if (this.props.text) {
    <span [ngClass]="this.props.textClass">{{ transloco(this.props.text) }}</span>
  }
</div>
